<header class="v-one-header">
  <div
    class="v-one-header__content"
    (click)="$event.stopPropagation()"
    (keydown)="onHeaderKeydown($event)"
    tabindex="0"
  >
    <div class="v-one-header__logo">
      <img
        src="assets/uplift/img/brand/v-one-insight-isologo_default.svg"
        alt="V-One Insight"
        class="v-one-header__logo-image v-one-header__logo-image--desktop"
      />

      <img
        src="assets/uplift/img/brand/v-one-insight-isotype.svg"
        alt="V-One Insight"
        class="v-one-header__logo-image v-one-header__logo-image--mobile"
      />
    </div>

    <div class="v-one-header__info">
      <app-company-selector> </app-company-selector>
      <div class="v-one-language-button-show">
        <app-language-selector></app-language-selector>
      </div>
    </div>

    <div class="v-one-header__menu-toggle">
      <v-one-button
        [icon]="'dots'"
        [iconType]="ICON_TYPE.FILLED"
        [variant]="'primary'"
        [className]="'v-one-header__menu-toggle'"
        (buttonClick)="onMenuToggle()"
        aria-label="Toggle menu"
      >
      </v-one-button>
    </div>
  </div>
</header>
